import { render, staticRenderFns } from "./AirReport.vue?vue&type=template&id=874cf240&scoped=true"
import script from "./AirReport.vue?vue&type=script&lang=js"
export * from "./AirReport.vue?vue&type=script&lang=js"
import style0 from "./AirReport.vue?vue&type=style&index=0&id=874cf240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874cf240",
  null
  
)

export default component.exports